@if (loading()) {
  <ul class="pc-strip" aria-busy="true" aria-label="Loading products">
    @for (i of skeletons; track i) {
      <li class="pc-card pc-card--skeleton" aria-hidden="true">
        <span class="pc-card__image"></span>
        <span class="pc-card__name"></span>
      </li>
    }
  </ul>
} @else if (cards().length) {
  <ul class="pc-strip" aria-label="Products">
    @for (card of cards(); track $index) {
      <li class="pc-card">
        <a class="pc-card__link" [routerLink]="card.link">
          <img class="pc-card__image" [src]="card.imageUrl" alt="" width="132" height="132"
               loading="lazy" decoding="async" (error)="onImageError($event)" />
          <span class="pc-card__name">{{ card.name }}</span>
        </a>
      </li>
    }
  </ul>
}
